import React from 'react';
import LocationTemplate from './LocationTemplate';

const GastonPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Gaston"
      stateName="North Carolina"
      countyName="Northampton"
      zipCodes={["27832"]}
      latitude={36.4973}
      longitude={-77.6469}
      population={1035}
      historicalFact="Incorporated in 1905, named after William Gaston, North Carolina Supreme Court Justice."
      nearbyTowns={[
        "Roanoke Rapids, NC",
        "Weldon, NC",
        "Garysburg, NC",
        "Thelma, NC",
        "Halifax, NC",
        "Littleton, NC",
        "Emporia, VA",
        "South Hill, VA"
      ]}
    />
  );
};

export default GastonPage;